import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PopSelect = _resolveComponent("PopSelect");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page",
    onClickRight: $options.showCondition
  }, {
    navRight: _withCtx(() => [$options.noCondition ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      class: "right-filter-no-select",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [_createTextVNode("更多筛选"), _createVNode(_component_van_icon, {
      color: "#f68657",
      name: "filter-o"
    })])) : (_openBlock(), _createElementBlock("a", {
      key: 1,
      class: "right-filter-select",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [_createTextVNode("已筛选"), _createVNode(_component_van_icon, {
      name: "filter-o",
      color: "red"
    })]))]),
    default: _withCtx(() => [_createVNode(_component_van_search, {
      modelValue: $data.searchForm.customerName,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.searchForm.customerName = $event),
      "show-action": "",
      placeholder: "输入客户名称",
      onSearch: $options.onSearch
    }, {
      action: _withCtx(() => [_createVNode(_component_van_button, {
        style: {
          "width": "100%"
        },
        type: "primary",
        size: "small",
        onClick: $options.onSearch,
        loading: $data.btnLoading
      }, {
        default: _withCtx(() => [_createTextVNode(" 查询 ")]),
        _: 1
      }, 8, ["onClick", "loading"])]),
      _: 1
    }, 8, ["modelValue", "onSearch"]), _createVNode(_component_van_divider, {
      style: {
        "margin": "0"
      }
    }), _createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      onOnListDataChange: $options.onListDataChange
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_cell, {
        title: item.customerName + ' - ' + item.productName,
        "arrow-direction": "",
        "is-link": "",
        to: {
          name: 'redemptionDetail',
          params: {
            redemptionId: item.id,
            customerId: item.customerId,
            productId: item.productId
          }
        }
      }, {
        label: _withCtx(() => [_createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("开放日: " + _toDisplayString(item.productOpenDate), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("赎回状态: " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'redemptionStatus', {
              redemptionStatus: item.redemptionStatus
            })), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("存续份额: " + _toDisplayString(item.leftShare), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("赎回份额: " + _toDisplayString(item.actualRedemptionShare ? item.actualRedemptionShare : item.applicationRedemptionShare), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("赎回类型: " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'redemptionType', {
              redemptionType: item.redemptionType
            })), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("赎回进度: " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'redemptionProgressType', {
              redemptionProgressType: item.redemptionProgressType
            })), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["title", "to"])]),
      _: 1
    }, 8, ["request", "requestParameter", "onOnListDataChange"]), _createVNode(_component_van_popup, {
      show: $data.showPopup,
      "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showPopup = $event),
      position: "right",
      style: {
        height: '100%',
        width: '85%'
      },
      closeable: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_PopSelect, {
        searchItems: $data.searchItems,
        onPopSelectConfirm: $options.handlePopSelectConfirm
      }, null, 8, ["searchItems", "onPopSelectConfirm"])]),
      _: 1
    }, 8, ["show"])]),
    _: 1
  }, 8, ["onClickRight"]);
}